module.exports = __webpack_public_path__ + "img/zoom-finish.7a1e4f45.png";